export default __webpack_public_path__ + "static/DefaultUI-b36f272a58702d0ca9ad1915f27f4501.png";